import React, { useRef, useState } from "react";
import { errorMessage, newRequestId } from "./coffeeApi";
import { todayPanama, useResource } from "./coffeeUi";
export default function CoffeeReset({ request, onClose, onSaved }) {
  const options = useResource("/internal/options", request);
  const [machine, setMachine] = useState(""),
    [until, setUntil] = useState(todayPanama),
    [counter, setCounter] = useState(""),
    [reason, setReason] = useState(""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [refresh, setRefresh] = useState(0);
  const previous = useResource(
    machine ? `/internal/previous/${machine}` : null,
    request,
    refresh
  );
  const identity = useRef({});
  const save = async (event) => {
    event.preventDefault();
    if (!previous.data || busy) return;
    setBusy(true);
    setError("");
    const data = { machine, until, counter: Number(counter), reason };
    const fingerprint = JSON.stringify(data);
    if (identity.current.fingerprint !== fingerprint)
      identity.current = { fingerprint, id: newRequestId() };
    try {
      await request(
        "/internal/resets",
        {
          ...data,
          requestId: identity.current.id,
          expectedVersion: previous.data.version,
        },
        "POST"
      );
      onSaved();
      onClose();
    } catch (err) {
      setError(errorMessage(err));
      if (err?.response?.status === 409) setRefresh((x) => x + 1);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="coffee-modal-backdrop">
      <div
        className="coffee-modal coffee-modal-small"
        role="dialog"
        aria-modal="true"
        aria-label="Registrar reinicio"
      >
        <div className="coffee-heading">
          <h2>Registrar reinicio de contador</h2>
          <button type="button" disabled={busy} onClick={onClose}>
            Cerrar
          </button>
        </div>
        <p>
          La siguiente lectura partirá de la nueva base. Los registros
          anteriores se conservarán.
        </p>
        {error && <p role="alert">{error}</p>}
        {options.error && <p role="alert">{options.error}</p>}
        <form onSubmit={save}>
          <fieldset disabled={busy}>
            <label>
              Máquina *
              <select
                required
                value={machine}
                onChange={(e) => setMachine(e.target.value)}
              >
                <option value="">Seleccionar máquina</option>
                {options.data?.machines.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.route} · {item.machine || item.serialNumber} ·{" "}
                    {item.serialNumber}
                  </option>
                ))}
              </select>
            </label>
            {previous.loading && <p role="status">Cargando lectura…</p>}
            {previous.error && <p role="alert">{previous.error}</p>}
            {previous.data && (
              <p>
                Último contador: {previous.data.counter ?? "Sin lectura"} ·
                Cierre: {previous.data.until || "—"}
              </p>
            )}
            <label>
              Fecha del reinicio *
              <input
                type="date"
                required
                min={previous.data?.until || undefined}
                value={until}
                onChange={(e) => setUntil(e.target.value)}
              />
            </label>
            <label>
              Nueva base *
              <input
                type="number"
                min="0"
                step="1"
                required
                value={counter}
                onChange={(e) => setCounter(e.target.value)}
              />
            </label>
            <label>
              Motivo *
              <textarea
                required
                maxLength={500}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </label>
            <div className="coffee-actions">
              <button
                className="coffee-primary"
                disabled={busy || !previous.data}
              >
                {busy ? "Guardando…" : "Guardar reinicio"}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
}
